import { API_BASE_URL } from "../config";
import type { SsmParameter } from "../types";

export async function fetchKioskParameters(): Promise<SsmParameter[]> {
  const response = await fetch(`${API_BASE_URL}/kiosks`);
  if (!response.ok) {
    throw new Error(`Kiosk lookup failed: ${response.status}`);
  }
  return response.json();
}
